export enum PropertyCategories {
  Residential = 19,
  Mix = 20,
  Institutional = 21,
  Commercial = 22,
  Industry = 24,
  Vacant = 25,
  AnyOther = 27,
}
